import React from 'react'
import {Helmet} from "react-helmet";
import Footer from '../components/Footer';

const About = () => {
  return (
    <div>
      <Helmet>
        <title>About | Syed Kaab Surkhi</title>
      </Helmet>
      <Footer/>
    </div>
  )
}

export default About